import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { clearContent } from "../../../store/actions/detailsDocument/preview";
import { loadDocumentDetail } from "../../../store/actions/documentPreview";
import { TransformComponent } from "react-zoom-pan-pinch";
import NoPreview from "../../documentDetails/noPreview";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

const Preview = ({scrollerAreaPreview}) => {
  const dispatch = useDispatch();
  
  const auth = useSelector(state => state.auth);
  const idAttachment = useSelector(state => state.precog.invoiceDetail?.data?.doc?.id); // "62a51f0f-31a0-4c72-bf0a-0f5d775fbd38";
  const main = useSelector(state => state.main);
  const isLoadingPreview = useSelector(state => state.documentPreview?.isLoadingDocument);
  const previewData = useSelector(state => state.documentPreview?.documents);
  
  const accountantSelected = main.accountantSelected;
  const accountantIdSelected = main.accountantIdSelected;
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;
  const previewImg = previewData?.[idAttachment]?.content;

  useEffect(() => {
    dispatch(loadDocumentDetail(
      auth, accountantSelected, accountantIdSelected, companySelected, clientIdSelected, idAttachment
    ));
  
    return () => {
      dispatch(clearContent());
    };
  }, []);

  useEffect(() => {
    if (!scrollerAreaPreview.current) return undefined;
    let ps = new PerfectScrollbar(scrollerAreaPreview.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [scrollerAreaPreview?.current]);

  return  (
    <div className="containerPreview" ref={scrollerAreaPreview} >
      <TransformComponent style={{height: "100%"}}>
        {isLoadingPreview ?
          <div style={{marginTop: "50px"}}>
            <FontAwesomeIcon
              icon={["far", "circle-notch"]}
              spin
              style={{ color: "#0090d1" }}
            />
          </div>
          :
          (<div style={{position: "relative", height: "100%"/* , transform: `scale(${zoomLevel}%)`*/}} >
            {previewImg ?             
              <img style={{transition:" transform 0.25s ease"}} src={`data:image/jpeg;base64, ${previewImg}`} alt="" />            
              : 
              <div>
                <NoPreview />
              </div>
            }
          </div>)
        }
      </TransformComponent>
    </div>);
};

export default Preview;